/* eslint-disable react/jsx-props-no-spreading */
import { forwardRef, HTMLAttributes, PropsWithChildren } from "react";

import {
  calloutTheme,
  CalloutThemeProps,
} from "hardcover-ui/theme/components/callout";
import classNames from "lib/classNames";

type Props = {
  size?: CalloutThemeProps["size"];
  variant?: CalloutThemeProps["variant"];
} & Partial<HTMLAttributes<HTMLDivElement>>;

const Callout = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
  ({ size = "md", variant = "primary", children, className, ...rest }, ref) => {
    const finalClassName = classNames(
      calloutTheme.variant[variant],
      calloutTheme.size?.[size],
      className,
    );

    const props = {
      ref,
      className: finalClassName,
      ...rest,
    };

    return <div {...props}>{children}</div>;
  },
);

export default Callout;
